import { render, staticRenderFns } from "./RoundsOfRewardsItemsList.vue?vue&type=template&id=472a6ab0&scoped=true&"
import script from "./RoundsOfRewardsItemsList.vue?vue&type=script&lang=js&"
export * from "./RoundsOfRewardsItemsList.vue?vue&type=script&lang=js&"
import style0 from "./RoundsOfRewardsItemsList.vue?vue&type=style&index=0&id=472a6ab0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472a6ab0",
  null
  
)

export default component.exports